import React, { useEffect, useState } from 'react';
import Breadcrumb from '../components/ShearedComponents/Breadcrumb';
import { FaSyncAlt } from "react-icons/fa";
import { Link } from 'react-router-dom';
import ProductItem from '../components/cart/ProductItem';
import { useDispatch, useSelector } from 'react-redux';
import emptyImg from "../assets/images/empty-cart.webp";
import { setAllItemsInCheckout } from '../features/checkout/checkoutSlice';

const Cart = () => {
    const { cartProducts, cartTotalAmount } = useSelector((state) => state.cartProducts);
    const dispatch = useDispatch();
    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    const handleSetToCheckout = () => {
        dispatch(setAllItemsInCheckout({ cartProducts, cartTotalAmount }))
    }

    let content = <h1>{translate ? "sumging is wrong" : "কিছু একটা ক্রটি হয়েছে"} </h1>;
    if (cartProducts?.length === 0) {
        content = (
            <div className='h-screen w-full  grid content-center justify-center'>
                <div className='h-full grid content-center justify-center text-center'>
                    <Link to="/">
                        <h3 className='text-xl font-poppins font-semibold hover:text-blue-700 cursor-pointer'>{"->"} {translate ? "Back to Home page" : "হোম পেইজে যান"} {'<-'} </h3>
                    </Link>
                    <img className='object-contain' src={emptyImg} alt="" />
                </div>
            </div>
        )
    }
    if (cartProducts?.length > 0) {
        content = (
            <>
                <div className='cart-list-page md:container md:mx-0 mx-auto'>
                    <Breadcrumb page="Cart" />
                    <div className='md:px-5 px-0 py-2'>
                        <div className="cart-hade-part">
                            <div className="flex mb-3 mx-2">
                                <div className='grid content-center relative md:-top-0 -top-1'>
                                    <FaSyncAlt className='font-normal text-gray-600 md:text-xl text-lg mr-2' />
                                </div>
                                <h3 className='md:text-2xl text-xl font-normal text-gray-600 pb-2'>{translate ? "Review Order" : "অডার পর্যালোচনা করুন"} </h3>
                            </div>
                            <div className=''>
                                <div className="grid grid-cols-10 content-center justify-center px-2 pb-3  bg-bnd-2 text-white py-2 font-bold">
                                    <div className=''>
                                    </div>
                                    <div className='col col-span-3 md:text-base text-sm'>
                                        {translate ? "Product" : "পণ্য"}
                                    </div>
                                    <div className='md:block hidden col col-span-2 md:text-base text-sm'>
                                        {translate ? "Price" : "দাম"}
                                    </div>
                                    <div className='md:block hidden c col-span-2  md:text-base text-sm'>
                                        {translate ? "Quntity" : "পরিমাণ"}
                                    </div>
                                    <div className=''>

                                    </div>
                                    <div className='md:block hidden text text-right  md:text-base text-sm'>
                                        {translate ? "Total" : "মোট"}
                                    </div>
                                    <div className='md:hidden block col md:col-auto col-span-5 text text-right  md:text-base text-sm'>
                                        {translate ? "Price" : "দাম"}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='cart-list'>
                            {cartProducts.map((item, index) => <ProductItem key={index} product={item} />)}
                            <div className='grid grid-cols-5'>
                                <div className='lg:block hidden col-span-3 '></div>
                                <div className='lg:col-span-2 col-span-5'>
                                    <div className='grid grid-cols-2 gap-2 py-2'>
                                        <div className='grid md:justify-start justify-end pl-1'>
                                            <p className='text-gray-600 mb-4'>{translate ? "Grand total" : "সর্বমোট"}</p>
                                            <Link to="/">
                                                <button className='bg-bnd-1 mb-2 text-white font-medium md:text-lg text-sm rounded-md font-poppins py-2 px-3'>{translate ? "Continew Shopping" : "কেনাকাটা চালিয়ে যান"}</button>
                                            </Link>
                                        </div>
                                        <div className='grid justify-end text-right md:pr-0 pr-3'>
                                            <p className='text-gray-600 mb-2'>{cartTotalAmount} {translate ? "BDT" : "টাকা"}</p>
                                            <Link to="/checkout" className='text-inherit ' onClick={cartProducts?.length > 0 && handleSetToCheckout}>
                                                <button className='bg-bnd-1 text-white font-medium  md:text-lg text-sm  rounded-md font-poppins py-2 px-3'>{translate ? "Checkout" : "চেকআউট"}</button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return content;
};

export default Cart;